<ng-container *ngIf="loaded">
  <li *ngIf="sidebarElement.subElements.length <= 1 || !fullWidth" [routerLink]="sidebarElement.route"
      [id]="sidebarElement.route + '-sidebar-element'"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{exact: false}"
      class="single-element"
      [ngClass]="elementClasses"
      matTooltip="{{sidebarElement.name}}"
      matTooltipPosition="right"
      [matTooltipDisabled]="fullWidth"
      (click)="onClickElement()">
    <span class="border-fill-small"></span>
    <mat-icon *ngIf="sidebarElement.icon && !imageIcon" [svgIcon]="sidebarElement.icon"></mat-icon>
    <img *ngIf="sidebarElement.icon && imageIcon" class="sidebar-icon" src="{{sidebarElement.icon}}"
         alt="{{sidebarElement.name}}">
    <span *ngIf="fullWidth" class="element-text">{{ sidebarElement.name }}</span>
  </li>

  <li *ngIf="sidebarElement.subElements.length > 1 && fullWidth"
      [id]="sidebarElement.route + '-sidebar-element'"
      class="sub-elements"
      [ngStyle]="{'height.px': subElementsHeight}">
    <div class="sub-elements-header" (click)="emitHeaderClicked(true)"
         [ngClass]="{'disabled': sidebarElement.isDisabled}">
      <span class="border-fill-small"></span>
      <mat-icon *ngIf="sidebarElement.icon && !imageIcon" [svgIcon]="sidebarElement.icon"></mat-icon>
      <img *ngIf="sidebarElement.icon && imageIcon" class="sidebar-icon" src="{{sidebarElement.icon}}"
           alt="{{sidebarElement.name}}">
      <span class="element-text">{{ sidebarElement.name }}</span>
      <span class="right-aligned">
                <mat-icon svgIcon="chevron-down" [ngClass]="{'sub-elements-active': subElementsActive}"></mat-icon>
            </span>
    </div>
    <div *ngIf="subElementsActive" class="sub-elements-body" @subElementState (click)="emitHeaderClicked(false)"
         fxFlex="100">
      <ul>
        <li *ngFor="let subElement of sidebarElement.subElements"
            [id]="subElement['route'] + '-sub-element-sidebar-element'"
            [routerLink]="subElement['route']"
            class="single-element"
            [ngClass]="elementClasses"
            routerLinkActive="active-link"
            [routerLinkActiveOptions]="{exact: false}" (click)="onClickElement(subElement)">
          <span class="border-fill-small"></span>
          <span class="dot">·</span>
          <span class="element-text">{{ subElement['name'] }}</span>
        </li>
      </ul>
    </div>
  </li>
</ng-container>
